import axios from './axiosInstances/axiosInstance';

export const addUpsellItems = (basketId, items) => {
  return axios.post(`/baskets/${basketId}/upsell`, [...items]);
};
